import React, { useContext } from "react";
import insta from "../../../Images/ms_instagram.svg";
import x from "../../../Images/x.svg";
import fb from "../../../Images/ms_facebook.svg";
import { MiniStoreThemeContext } from "../../../MiniStoreContexts/MiniStoreThemeContext";
import styled from "styled-components";

const SocialButtonsFooter = () => {
  const { theme } = useContext(MiniStoreThemeContext);
  let url = "";

  const socialButton = (socialType) => {
    if (socialType === "instagram") {
      url = theme?.insta_url || "https://www.instagram.com";
    } else if (socialType === "tweeter") {
      url = theme?.x_url || "https://twitter.com"; // tweeter is now called X
    } else if (socialType === "facebook") {
      url = theme?.fb_url || "https://www.facebook.com";
    }

    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };
  return (
    <div className="d-flex justify-content-center align-items-center gap-3 pt-3 my-3">
      <SocialIcon
        className="cursor-pointer"
        src={insta}
        alt="Social Logo Instagram"
        onClick={() => socialButton("instagram")}
      />
      <SocialIcon
        className="cursor-pointer"
        src={x}
        alt="Social Logo X"
        onClick={() => socialButton("tweeter")}
      />
      <SocialIcon
        className="cursor-pointer"
        src={fb}
        alt="Social Logo Facebook"
        onClick={() => socialButton("facebook")}
      />
    </div>
  );
};

export default SocialButtonsFooter;

const SocialIcon = styled.img`
  cursor: pointer;
  height: 40px;
  width: 40px;

  @media (max-width: 450px) {
    height: 20px;
    width: 20px;
  }
`;
